module.exports = __webpack_public_path__ + "img/nav6.4eaabc0b.svg";